export default __webpack_public_path__ + "static/media/SkybagsRubikPolyester1.4118ced8.jpg";